import { useAppDispatch, useAppSelector } from "@/app/hooks";
import type { SelectedMenuItem } from "@/types";
import { Box, Button, Image, Stack, Text } from "@mantine/core";
import { selectedMenuItem, setSelectedMenuItem } from "../menuSlice";
import SwipeableOffsetDrawer from "./SwipeableOffsetDrawer";

interface MenuTabProps {
    item: Exclude<SelectedMenuItem, 'closed'>;
    label: string;
    icon: string;
    selectedIcon: string;
    /** Drawer header content shown under the drag handle. */
    title: React.ReactNode;
    children?: React.ReactNode;
}

/** A bottom-menu button that opens its own swipeable drawer. */
const MenuTab: React.FC<MenuTabProps> = ({ item, label, icon, selectedIcon, title, children }) => {
    const dispatch = useAppDispatch();
    const currentMenuItem = useAppSelector(selectedMenuItem);
    // Explore is the resting tab: it stays highlighted while every drawer is closed,
    // and tapping it closes the open drawer instead of opening one.
    const isExplore = item === 'explore';
    const selected = currentMenuItem === item || (isExplore && currentMenuItem === 'closed');
    const close = () => dispatch(setSelectedMenuItem('closed'));

    return (
        <>
            <Button pl={1} pr={1} h={70} fullWidth variant='transparent' onClick={() => dispatch(setSelectedMenuItem(isExplore ? 'closed' : item))}>
                <Stack gap={6} align='center' justify='center'>
                    <Box>
                        <Image fit="contain" src={selected ? selectedIcon : icon} alt={`${label} Icon`} height={20} style={{ alignSelf: 'center' }} />
                    </Box>
                    <Text size='sm' c={selected ? 'white' : 'pq-gray'}>{label}</Text>
                </Stack>
            </Button>
            <SwipeableOffsetDrawer opened={currentMenuItem === item} onClose={close} title={title}>
                {children}
            </SwipeableOffsetDrawer>
        </>
    );
}

export default MenuTab;
